export enum DrugDetailArticleTypes {
    PRECAUTION = 'drug_precautions',
    DOCTOR = 'drug_article_doctor',
    ORAL = 'drug_article_oral',
    OCCASIONAL_SIDE_EFFECT = 'drug_ose',
    RARE_SIDE_EFFECT = 'drug_rse',
    LONG_TERM_SIDE_EFFECT = 'drug_ltse'
}
